module.exports = __webpack_public_path__ + "img/50.520fdacd.png";